import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 12c0-5.211 3.956-9.496 9.022-10v20C5.956 21.496 2 17.211 2 12ZM13.027 13.005V22c4.736-.471 8.503-4.247 8.973-8.995h-8.973ZM22 10.995C21.53 6.247 17.763 2.471 13.027 2v8.995H22Z" />
  </svg>
);
export default IconDrillingPartRightFilledSizeM;
